import GallerySimple from "../blocks/gallery-simple";
import Gallery from "../blocks/gallery";

const TemplateProducts = {
  init() {
    console.log("TemplateProducts.init() is running");
    new GallerySimple(".gallery-simple");
    new Gallery(".gallery");
  },
};

export default TemplateProducts;
